
import React from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

const DeleteConfirmation = ({ showModal, hideModal, handleRedeemVoucher, voucherdata }) => {
    return (
        <Modal
            isOpen={showModal}
            toggle={hideModal}
            size="lg"
            style={{ maxWidth: '50%' }}
        >
            <ModalHeader toggle={hideModal}><h3>Redeem Confirmation</h3></ModalHeader>
            <ModalBody><div className=""><h5>Are you sure you want to redeem the voucher ?</h5></div></ModalBody>
            <ModalFooter>
                <Button onClick={hideModal}>
                    Cancel
                </Button>
                <Button color="primary" onClick={() => { handleRedeemVoucher(voucherdata.voucherNumber); hideModal(); }}>
                    Redeem
                </Button>
            </ModalFooter>
        </Modal >
    )
}
export default DeleteConfirmation;